<template>
  <div class="m-multiselect-choices">
    <MMultiSelectChoiceOptionGroup
      v-for="(chunk, chunkId) in chunkedChoices"
      :key="chunkId"
      v-observe-visibility="isVisible ? getObserverConfig(chunkId) : false"
      class="m-lazy-render__chunk"
      :payload="chunk"
      :style="getCssVarsForChunk(chunkId)"
      :chunk-is-visible="chunkIsVisible(chunkId)"
      :data-id="chunkId"
      :class="{
        'm-lazy-render__lazy-enabled': lazyRender,
        'm-lazy-render__chunk_active': lazyRender && selectedItem && chunkId === selectedItem.chunkId,
        'm-lazy-render__chunk_visible': lazyRender && chunkIsVisible(chunkId),
      }"
      :value-set="valueSet"
      :id-attr="idAttr"
      :current-focus-item-id="currentFocusItemId"
      :display-id-attr="displayIdAttr"
      :disable-option-predicate="disableOptionPredicate"
      :format-fn="formatFn"
      :disable-add-items="disableAddItems"
      :show-id="showId"
      :value="value"
      :text-attr="textAttr"
      @toggleItem="$emit('toggleItem', $event)"
      @handle-click-navigation="$emit('handle-click-navigation', $event)"
    />
  </div>
</template>

<script>
  import LazyRenderMixin from 'components/mixins/LazyRenderMixin';
  import MMultiSelectChoiceOptionGroup from 'components/Inputs/Select/MMultiSelect/MMultiSelectChoiceOptionGroup';

  export default {
    name: 'MMultiSelectChoices',
    components: {MMultiSelectChoiceOptionGroup},
    mixins: [LazyRenderMixin],
    props: {
      choices: {
        type: Array,
        default: Array
      },
      isVisible: {
        type: Boolean,
        default: false
      },
      selectedItem: {
        type: Object,
        default: null
      },
      value: {
        type: Array,
        required: true
      },
      idAttr: {
        type: String,
        required: true
      },
      currentFocusItemId: {
        type: [Number, String],
        default: null
      },
      disableOptionPredicate: {
        type: Function,
        default: () => false
      },
      disableAddItems: {
        type: Boolean,
        default: false
      },
      textAttr: {
        type: String,
        required: true
      },
      showId: {
        type: Boolean,
        default: false
      },
      displayIdAttr: {
        type: [String, Boolean],
        default: false
      },
      formatFn: {
        type: Function,
        default: undefined
      }
    },
    computed: {
      chunkedChoices () {
        if (this.lazyRender) {
          return LazyRenderMixin.computed.chunkedChoices.call(this);
        }
        return [this.choices];
      },
      valueSet () {
        return new Set(this.value);
      }
    }
  };
</script>
